import { AircraftImpl } from './Aircraft';
import { RouteImpl } from './Route';
import { AirportImpl } from './Airport';
import OlMap from 'ol/Map';
import { MapboxVector } from 'ol/layer';
import View from 'ol/View';
import { Overlay } from 'ol';
export class MapV2 {
    constructor(config, airports, flights, callbacks) {
        this._flights = [];
        this._routes = [];
        this._airports = [];
        this.selectedAirportOverlay = null;
        this.hoverAirportOverlay = null;
        this.hoverFlightOverlay = null;
        this._config = config;
        this._callbacks = callbacks;
        this.initLayers(airports, flights);
        this.initMap();
        this.restoreLayers();
        this.initEvents();
    }
    get activeFlight() {
        return this._activeFlight;
    }
    set activeFlight(flight) {
        this.restoreLayers();
        this._activeFlight = flight;
        this._callbacks.onFlightClick(flight !== null ? flight.data : null);
        if (flight !== null) {
            this._activeFlight.isActive = true;
            this._callbacks.onFlightClick(flight.data);
        }
    }
    get activeAirport() {
        return this._activeAirport;
    }
    set activeAirport(airport) {
        if (!airport) {
            this.restoreLayers();
        }
        else {
            this.removeAll();
        }
        this._callbacks.onAirportClick(airport ? airport.data : null);
        this._activeAirport = airport;
        if (airport !== null) {
            this._activeAirport.isActive = true;
            this.selectedAirportOverlay.setPosition(airport.coordinates);
            if (this._config.isMobileMode) {
                this.setCenterTo(airport, 3);
            }
            for (const route of airport.routes) {
                this.show(route);
                this.show(route.departure);
                this.show(route.arrival);
                if (route.aircraft) {
                    this.show(route.aircraft);
                }
            }
        }
    }
    get hoveredAirport() {
        return this._hoveredAirport;
    }
    set hoveredAirport(airport) {
        if (airport === null) {
            this._callbacks.onAirportHover(null);
            this._hoveredAirport = null;
            return;
        }
        if (!this.hoveredAirport) {
            this._hoveredAirport = airport;
            this.hoverAirportOverlay.setPosition(this.hoveredAirport.coordinates);
            this._callbacks.onAirportHover(airport.data);
        }
    }
    get hoveredFlight() {
        return this._hoveredFlight;
    }
    set hoveredFlight(flight) {
        if (flight === null) {
            this._callbacks.onFlightHover(null);
            this._hoveredFlight = null;
            return;
        }
        if (!this.hoveredFlight) {
            this._hoveredFlight = flight;
            this._callbacks.onFlightHover(flight.data);
            this.hoverFlightOverlay.setPosition(this.hoveredFlight.coordinates);
        }
        this.hoverFlightOverlay.setPosition(flight.coordinates);
        if (this._config.isMobileMode) {
            this.setCenterTo(flight);
        }
    }
    initMap() {
        this.hoverAirportOverlay = new Overlay({
            element: this._config.hoverAirportOverlayContainer
        });
        this.hoverFlightOverlay = new Overlay({
            element: this._config.flightOverlayContainer,
            offset: [0, 3]
        });
        this.selectedAirportOverlay = new Overlay({ element: this._config.selectedAirportOverlayContainer });
        this._map = new OlMap({
            target: this._config.container,
            overlays: [this.hoverAirportOverlay, this.hoverFlightOverlay, this.selectedAirportOverlay],
            layers: [
                new MapboxVector({
                    zIndex: 0,
                    styleUrl: this._config.style,
                    accessToken: this._config.accessToken
                })
            ],
            view: new View({
                center: [0, 0],
                zoom: 0
            })
        });
    }
    initLayers(airports, flights) {
        for (const airport of airports) {
            const airportInstance = new AirportImpl(airport, this._config);
            airportInstance.create();
            this._airports.push(airportInstance);
        }
        for (const flight of flights) {
            const departureAirport = this._airports.find(airport => airport.data.iata === flight.departure.airport.iata);
            const arrivalAirport = this._airports.find(airport => airport.data.iata === flight.arrival.airport.iata);
            let route;
            // if flight in sky, add aircraft to route instance, otherwise, create Route without related aircraft
            if (flight.pathCompletion > 0 && flight.pathCompletion < 100) {
                const aircraft = new AircraftImpl(flight, this._config, departureAirport, arrivalAirport);
                aircraft.create();
                this._flights.push(aircraft);
                route = new RouteImpl(flight, this._config, arrivalAirport, departureAirport, aircraft);
            }
            else {
                route = new RouteImpl(flight, this._config, arrivalAirport, departureAirport);
            }
            route.create();
            departureAirport.routes.push(route);
            arrivalAirport.routes.push(route);
            this._routes.push(route);
        }
        console.log(this);
    }
    restoreLayers() {
        this.removeAll();
        this.deactivateAll();
        this.renderRoutesInSky();
        this.renderAircrafts();
        this.renderAirports();
    }
    renderRoutesInSky() {
        for (const route of this._routes) {
            if (route.isInSky) {
                this.show(route);
            }
        }
    }
    renderAircrafts() {
        for (const aircraft of this._flights) {
            this.show(aircraft);
        }
    }
    renderAirports() {
        for (const airport of this._airports) {
            this.show(airport);
        }
    }
    initEvents() {
        this._map.on('click', this.clickEventsHandler.bind(this));
        this._map.on('pointermove', this.mouseOverEventHandler.bind(this));
    }
    // TODO: duplicated code
    clickEventsHandler(evt) {
        const feature = this.getFeatureFromEvent(evt);
        if (!feature) {
            this.activeAirport = null;
            this.activeFlight = null;
            return;
        }
        const instance = feature.get('feature');
        if (instance instanceof AirportImpl) {
            this.activeFlight = null;
            this.activeAirport = instance;
        }
        else if (instance instanceof AircraftImpl) {
            this.activeAirport = null;
            this.activeFlight = instance;
        }
        else {
            this.activeAirport = null;
            this.activeFlight = null;
        }
    }
    mouseOverEventHandler(evt) {
        const feature = this.getFeatureFromEvent(evt);
        if (!feature) {
            if (this.hoveredAirport) {
                this.hoveredAirport = null;
            }
            if (this.hoveredFlight) {
                this.hoveredFlight = null;
            }
            return;
        }
        const instance = feature.get('feature');
        if (instance instanceof AirportImpl) {
            this.hoveredAirport = instance;
        }
        else if (instance instanceof AircraftImpl) {
            this.hoveredFlight = instance;
        }
    }
    // end TODO
    deactivateAll() {
        for (const feature of this._airports) {
            feature.isActive = false;
        }
        for (const feature of this._flights) {
            feature.isActive = false;
        }
    }
    removeAll() {
        for (const route of this._routes) {
            this.remove(route);
        }
        for (const airport of this._airports) {
            this.remove(airport);
        }
        for (const aircraft of this._flights) {
            this.remove(aircraft);
        }
    }
    setCenterTo(feature, maxZoom = 5) {
        const view = this._map.getView();
        const simpleGeom = feature.geometry.getSimplifiedGeometry(10);
        view.fit(simpleGeom, { maxZoom });
    }
    show(feature) {
        if (!feature.isOnMap) {
            this._map.addLayer(feature.layer);
            feature.isOnMap = true;
        }
    }
    remove(feature) {
        this._map.removeLayer(feature.layer);
        feature.isOnMap = false;
    }
    getFeatureFromEvent(event) {
        return this._map.forEachFeatureAtPixel(event.pixel, feature => {
            return feature;
        });
    }
    clearActiveAirport() {
        this.activeAirport = null;
    }
    setHoverFlight(flight) {
        for (const flightInstance of this._flights) {
            if (flightInstance.data.uniqueId === flight.uniqueId) {
                this.hoveredFlight = flightInstance;
                break;
            }
        }
    }
}
